import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { IOSSwitch } from '../IOSSwitch';

interface EthernetDeviceDDosMitigationEditProps {
  onSubmit: () => void;
  metroId: string;
  dDosEnabled: boolean;
}

export const EthernetDeviceDDosMitigationEdit = ({ onSubmit, metroId, dDosEnabled }: EthernetDeviceDDosMitigationEditProps) => {
  const api = useApi();
  const [newDDosEnabled, setNewDDosEnabled] = useState<boolean>(dDosEnabled);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewDDosEnabled(e.target.checked);
    setDisableSubmit(e.target.checked === dDosEnabled);
  };

  const editDDos = useMutation(api.toggleMetroDosApiV1ToggleMetroDenialOfServicePost, {
    onSuccess() {
      toast.success(`${newDDosEnabled ? 'Enabled' : 'Disabled'} DDoS mitigation successfully.`);
      onSubmit();
    },
    onError: (error) => {
      apiError(error);
      setDisableSubmit(false);
    },
  });

  const handleSubmit = () => {
    setDisableSubmit(true);
    editDDos.mutate({
      metro_id: metroId,
      enabled: newDDosEnabled || false
    });
  };

  return (
    <Box pt={2}>
      <Typography variant="body1" sx={{ mb: 6 }}>
        Enable or disable DDos mitigation.
      </Typography>
      <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
        <FormControlLabel
          value="top"
          control={
            <IOSSwitch color="primary" checked={newDDosEnabled} onChange={handleChange} />
          }
          label={newDDosEnabled ? 'Enabled' : 'Disabled'}
          labelPlacement="bottom"
          sx={(theme) => ({ '&:hover': { color: theme.palette.primary.main } })}
          componentsProps={{
            typography: {
              sx: (theme) => ({
                fontSize: 12,
                color: !newDDosEnabled ? theme.palette.grey[600] : theme.palette.primary.main,
              }),
            },
          }}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={disableSubmit}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
